import {
  FULL_LOGO_ISO_OFFSET,
  FULL_LOGO_SIZE,
  FULL_LOGO_WORDMARK_OFFSET,
  IsoShapes,
  LOGO_ACCENT_COLOR,
  LOGO_INK_COLOR,
  type LogoBaseProps,
  WordmarkShapes,
  logoA11yProps,
  scaledWidth,
} from './logoShapes';

export type LibertifyLogoProps = LogoBaseProps & {
  /** Color of the iso's two bars. Defaults to the brand teal. */
  accentColor?: string;
};

/**
 * LibertifyLogo — the full logo: brand mark (iso) followed by the
 * "Libertify" wordmark, composed from the same shapes as `LibertifyIso` and
 * `LibertifyWordmark`. At the default height of 30px the iso is 24px tall.
 *
 * @example
 * ```tsx
 * import { LibertifyLogo } from '@libertify/ui';
 *
 * <LibertifyLogo title={appTitle} />
 * ```
 */
export const LibertifyLogo = ({
  height = FULL_LOGO_SIZE.height,
  color = LOGO_INK_COLOR,
  accentColor = LOGO_ACCENT_COLOR,
  title,
  className,
  style,
}: LibertifyLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${FULL_LOGO_SIZE.width} ${FULL_LOGO_SIZE.height}`}
    width={scaledWidth(FULL_LOGO_SIZE, height)}
    height={height}
    fill="none"
    className={className}
    style={style}
    {...logoA11yProps(title)}
  >
    <g
      transform={`translate(${FULL_LOGO_ISO_OFFSET.x} ${FULL_LOGO_ISO_OFFSET.y})`}
    >
      <IsoShapes color={color} accentColor={accentColor} />
    </g>
    <g
      transform={`translate(${FULL_LOGO_WORDMARK_OFFSET.x} ${FULL_LOGO_WORDMARK_OFFSET.y})`}
    >
      <WordmarkShapes color={color} />
    </g>
  </svg>
);

export default LibertifyLogo;
